<template>
  <el-dialog :visible.sync="isShow"
             title="修改模板问题"
             :close-on-click-modal="false"
             custom-class="system_manager_dialog"
             width="450px">
    <div id="contentWrap">
      <div class="content">
        <el-form ref="form"
                 :model="form"
                 :rules="rules"
                 label-width="80px">
          <el-form-item label="模板问题" prop="title">
            <el-input v-model="form.title"
                      placeholder="请输入模板问题"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-switch v-model="form.is_usage"></el-switch>
          </el-form-item>
          <el-form-item label="问题类型">
            <el-switch v-model="form.template_type"
              active-text="勾选"
              active-value="check"
              inactive-text="选是否"
              inactive-value="choose"></el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div class="btns">
        <el-button type="primary" :loading="repeatReq"  @click="doSubmit">保存</el-button>
        <el-button type="danger" @click="doCancel">取消</el-button>
        <!-- <div class="btn save"
             @click="doSubmit">保存</div>
        <div class="btn cancel"
             @click="doCancel">取消</div> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {editTplQuestion} from "@/api/system_manager/api";
  export default {
    name: "eva-edit",
    props: {
      visible: {
        type: Boolean,
        required: true,
        default: false,
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        repeatReq: false,
        form: {
          eva_template_id: this.item.eva_template_id,
          title: this.item.title,
          template_type: this.item.template_type,
          is_usage: Boolean(this.item.is_usage == 0),
        },
        rules: {
          title: [
            { required: true, message: '请输入模板问题', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ]
        }
      };
    },
    computed: {
      isShow: {
        get(){
          return this.visible;
        },
        set(bool){
          this.$emit("hideDialog", bool, false);
          this.resetForm();
        }
      },
    },
    methods: {
      doSubmit() {
        if(this.repeatReq){return;}
        this.repeatReq = true;
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.form.is_usage
              ? this.$set(this.form, "is_usage", 0)
              : this.$set(this.form, "is_usage", 1);
            editTplQuestion({...this.form})
              .then((res)=>{
                // console.log(res);
                if(Number(res.data.status) === 0) {
                  this.resetForm();
                  this.$emit("hideDialog", false, true);
                } else {
                  this.$message.error(res.data.msg);
                }
                this.repeatReq = false;
              })
              .catch((err)=>{
                this.repeatReq = false;
                console.error(err);
              });
          } else {
            this.repeatReq = false;
            console.error('error submit!!');
            return false;
          }
        });
      },
      doCancel() {
        this.isShow = false;
      },
      resetForm() {
        this.$refs["form"].resetFields();
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import "~@/assets/css/variable";
  #contentWrap {
    .content {
      padding: 20px 0;
    }
    .el-button--danger {
      background-color $color_err
    }
  }
</style>
